import { AgeContainerCompare } from "app/pages/website-analysis/demographics/StyledComponents";
import type {
    IAgeDistributionData } from "app/pages/website-analysis/demographics/AgeDistributionBarChartCompared/AgeDistributionBarChartCompared";
import {
    AgeDistributionBarChartCompared
} from "app/pages/website-analysis/demographics/AgeDistributionBarChartCompared/AgeDistributionBarChartCompared";
import type { FC } from "react";

interface IAgeDistributionCompare {
    isLoading: boolean;
    ageDistributionData: IAgeDistributionData;
    downloadExcelUrl: string;
}

export const AgeDistributionCompare: FC<IAgeDistributionCompare> = (props) => {
    const { isLoading, ageDistributionData, downloadExcelUrl } = props;
    return (
        <AgeContainerCompare>
            <AgeDistributionBarChartCompared
                data={ageDistributionData}
                isLoading={isLoading}
                downloadExcelUrl={downloadExcelUrl}
            />
        </AgeContainerCompare>
    );
};
